import { NumberFormatBase } from "react-number-format";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx/xlsx.mjs";
import * as _ from "lodash";

// components
import AnimationLoading from "../../../components/Animationloading";
import DownloadExcelButton from "./../DownloadExcelButton";
import { errorSwal, successSwal } from "../../../helper/sweetalert";
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from "../../../const";

// apollo-client
import { CREATE_MANY_PRODUCTS } from "../../../apollo/product/Mutation";
import { useLazyQuery, useMutation } from "@apollo/client";

// icons
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Button,
  ButtonGroup,
  Card,
  Form,
  Spinner,
  Table,
  Row,
  Col
} from "react-bootstrap";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { GET_SUVIVALS } from "../../../apollo/unit/Query";

function AddProductExcelV1() {
  const history = useHistory();
  const [stockDatas, setStockDatas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [survivalDatas, setSurvivalDatas] = useState([]);
  const [selectSurvival, setSelectSurvival] = useState()

  // apollo client hooks
  const [createManyProducts, { loading: createManyProductsLoading }] = useMutation(CREATE_MANY_PRODUCTS);
  const [getSurvivalData, { loading: loadingSurvival, data: survivalDatasLoad }] = useLazyQuery(GET_SUVIVALS, {
    fetchPolicy: "cache-and-network"
  });

  useEffect(() => {
    // Get shop data from localStorage
    const userData = localStorage.getItem("SHOP_DATA");
    if (userData) {
      const locals = JSON.parse(userData);
      if (locals) {
        fetchSurvivalDatas(locals.id);
      }
    }
  }, [])

  useEffect(() => {
    if (survivalDatasLoad) {
      setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
    }
  }, [survivalDatasLoad]);


  // Fetch survival data based on shop ID
  const fetchSurvivalDatas = async (shopId) => {
    if (loadingSurvival) return; // Prevent re-triggering if already loading

    try {
      await getSurvivalData({
        variables: {
          where: {
            shop: shopId,
            status: true,
            isDeleted: false
          }
        }
      });
    } catch (err) {
      console.log("Load survival error: ", err);
    }
  }

  const generateNumberByDateTime = () => {
    const date = new Date();
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    const generatedNumber = year + month + day + hours + minutes + seconds;
    return generatedNumber.slice(-6);
  };
  
  //* Handle file upload validation data empty
  const handleFileUpload = (event) => {
    setError(null);
    setIsLoading(true);
  
    try {
      const file = event.target.files[0];
      if (!file) throw new Error("No file selected");
  
      const reader = new FileReader();
  
      reader.onload = async (e) => {
        try {
          const stockDatas = e.target.result;
          const workbook = XLSX.read(stockDatas, { type: "binary" });
          
          if (workbook.SheetNames.length === 0) {
            throw new Error("Excel file contains no sheets");
          }
  
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  
          // Validate at least 2 rows (header + data)
          if (rawData.length < 2) {
            throw new Error("File must contain at least one data row");
          }
  
          // Process data rows (skip header)
          const _newStocks = rawData.slice(1)
            // Filter out empty rows
            .filter(row => row.some(cell => 
              cell !== undefined && 
              cell !== null && 
              String(cell).trim() !== ''
            ))
            // Map valid rows
            .map((row, index) => {
              // Validate required fields
              if (!row[1] && !row[0]) {
                throw new Error(`Missing required fields in row ${index + 2}`);
              }
  
              return {
                id: index,
                barCode: row[0]?.toString() || generateNumberByDateTime(index),
                name: row[1]?.toString()?.trim() || `Unnamed Item ${index + 1}`,
                unit: row[2]?.toString()?.trim() || "",
                size: row[3]?.toString()?.trim() || "",
                amount: Math.max(0, Number(row[4])) || 0,
                originPrice: Math.max(0, Number(row[5])) || 0,
                price1: Math.max(0, Number(row[6])) || 0,
                price2: Math.max(0, Number(row[7])) || 0,
                price3: Math.max(0, Number(row[8])) || 0,
                currency: row[9] ? row[9] : "ກີບ",
                categoryName: row[10]?.toString()?.trim() || "",
                brandName: row[11]?.toString()?.trim() || "",
                subBrandName: row[12]?.toString()?.trim() || "",
                shippingCost: Math.max(0, Number(row[13])) || 0
              };
            });
  
          if (_newStocks.length === 0) {
            throw new Error("No valid data found in the spreadsheet");
          }
  
          setStockDatas(_newStocks);
          setIsLoading(false);
  
        } catch (error) {
          console.error("Processing error:", error);
          setError(error.message);
          setIsLoading(false);
        }
      };
  
      reader.onerror = () => {
        setError("Failed to read file");
        setIsLoading(false);
      };
  
      reader.readAsBinaryString(file);
  
    } catch (error) {
      console.error("Upload error:", error);
      setError(error.message);
      setIsLoading(false);
    }
  };

  const _onCreateManyStock = async () => {
    try {
      if (createManyProductsLoading) return;
      let stocks = [];
      // TODO: Get shop id
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      for (let stock of stockDatas) {
        let priceOptions = [];
        if (stock.price1 > 0)
          priceOptions.push({ price: parseFloat(stock.price1.toString().replace(/,/g, "")) ?? 0, contain: "1" });
        if (stock.price2 > 0)
          priceOptions.push({ price: parseFloat(stock.price2.toString().replace(/,/g, "")) ?? 0, contain: "0" });
        if (stock.price3 > 0)
          priceOptions.push({ price: parseFloat(stock.price3.toString().replace(/,/g, "")) ?? 0, contain: "0" });

        console.log("priceOptions:", priceOptions);

        const _newStock = {
          barCode: stock?.barCode,
          name: stock?.name,
          unit: stock?.unit,
          size: stock?.size,
          categoryName: stock?.categoryName,
          brandName: stock?.brandName,
          subBrandName: stock?.subBrandName,
          amount: parseFloat(stock?.amount.toString().replace(/,/g, "")) ?? 0,
          originPrice:
            parseFloat(stock?.originPrice.toString().replace(/,/g, "")) ?? 0,
          priceOptions,
          currency: stock?.currency,
          note: stock?.note ?? "",
          shop: shopId,
          shippingCost: parseFloat(stock?.shippingCost.toString().replace(/,/g, "")) ?? 0
        };
        if (!_.isEmpty(selectSurvival)) {
          stocks.push({ ..._newStock, survivalId: selectSurvival });
        } else {
          stocks.push({ ..._newStock });
        }
      }

      // create products
      await createManyProducts({
        variables: {
          data: stocks,
          where: {
            shop: shopId,
          },
        },
      });

      // alert success
      successSwal(`ເພີ່ມສິນຄ້າເລັດແລ້ວ`);
      history.goBack();

    } catch (error) {
      console.log(error);
      errorSwal(`ເກີດຂໍ້ຜິດພາດ`);
    }
  };

  return (
    <div style={{ padding: "2em" }}>
      <BreadCrumbComponent goback={() => history.goBack()}
        txtFirst="ສາງສິນຄ້າ"
        txtSecond="ເພິ່ມສິນຄ້າຈາກ Excel" />

      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ເລືອກ File Excel ຂອງທ່ານ</Form.Label>
            <Form.Control type="file"
              onChange={handleFileUpload}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ໝາຍເລກລອດ</Form.Label>
            <Form.Select onChange={(e) => setSelectSurvival(e?.target?.value)} value={selectSurvival} aria-label="Default select example">
              <option>--ເລືອກ--</option>
              {survivalDatas.map((_option, _index) => (
                <option value={_option?.id}>{_option?.survivalNumber}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <div style={{ height: 30 }} />
            <DownloadExcelButton />
            &nbsp;
            <Button
              disabled={stockDatas?.length <= 0 ? true : false}
              style={{
                background: LINEAR_GRADIENT_BG,
                border: "none",
                color: COLOR_WHITE, width: 100
              }}
              onClick={() => {
                if (stockDatas?.length <= 0) return;
                _onCreateManyStock();
              }}>
              {createManyProductsLoading ? (
                <Spinner size="sm" animation="border" />
              ) : (
                "ບັນທືກ"
              )}
            </Button>  &nbsp;
            <Button
              disabled={stockDatas?.length <= 0 ? true : false}
              onClick={() => setStockDatas([])}
              variant="danger"
              style={{ width: 100 }}>ຍົກເລີກ</Button>
          </Form.Group>
        </Col>
      </Row>


      {error && <div> Error to import file</div>}
      {isLoading && <AnimationLoading />}

      <Card style={{ border: "none", marginTop: "1em" }}>
        {stockDatas?.length > 0 && !isLoading && (
          <Table responsive>
            <thead>
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ borderBottom: "none" }}>ບຣາໂຄດ</th>
                <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ</th>
                <th style={{ borderBottom: "none" }}>ຫົວຫນວ່ຍ</th>
                <th style={{ borderBottom: "none" }}>ຂະໜາດ</th>
                <th style={{ borderBottom: "none" }}>ຈໍານວນ</th>
                <th style={{ borderBottom: "none" }}>ລາຄາຕົ້ນທືນ</th>
                <th style={{ borderBottom: "none" }}>ລາຄາຂາຍ 1</th>
                <th style={{ borderBottom: "none" }}>ລາຄາຂາຍ 2</th>
                <th style={{ borderBottom: "none" }}>ລາຄາຂາຍ 3</th>
                <th style={{ borderBottom: "none" }}>ສະກຸນເງິນ</th>
                <th style={{ borderBottom: "none" }}>ປະເພດ</th>
                <th style={{ borderBottom: "none" }}>ແບຣນ</th>
                <th style={{ borderBottom: "none" }}>ຊັບແບຣນ</th>
                <th style={{ borderBottom: "none" }}>ຄ່າຈັດສົ່ງ</th>
                <th style={{ borderBottom: "none" }}>ຈັດການ</th>
              </tr>
            </thead>
            <tbody>
              {stockDatas?.length > 0 &&
                stockDatas?.map((stock, index) => (
                  <tr key={index} style={{ whiteSpace: "nowrap" }}>
                    <td>
                      <Form.Control
                        type="input"
                        value={stock?.barCode}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].barCode = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="input"
                        value={stock?.name}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].name = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="input"
                        nam="unit"
                        value={stock?.unit}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].unit = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="input"
                        name="size"
                        value={stock?.size}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].size = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <NumberFormatBase
                        name="amount"
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].amount = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                        value={stock?.amount}
                        className="form-control"
                        placeholder="0"
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </td>
                    <td>
                      <NumberFormatBase
                        name="originPrice"
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].originPrice = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                        value={stock?.originPrice}
                        className="form-control"
                        placeholder="0"
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </td>
                    <td>
                      <NumberFormatBase
                        name="price1"
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].price1 = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                        value={stock?.price1}
                        className="form-control"
                        placeholder="0"
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </td>
                    <td>
                      <NumberFormatBase
                        name="price2"
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].price2 = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                        value={stock?.price2}
                        className="form-control"
                        placeholder="0"
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </td>
                    <td>
                      <NumberFormatBase
                        name="price3"
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].price3 = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                        value={stock?.price3}
                        className="form-control"
                        placeholder="0"
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </td>
                    <td>
                      <ButtonGroup aria-label="Basic example">
                        <Button
                          style={{
                            backgroundColor:
                              stock?.currency == "ກີບ" ? "green" : "#eee",
                            color: stock?.currency == "ກີບ" ? "#ffff" : "#000",
                            width: 50,
                            marginLeft: 12,
                            borderWidth: 0,
                          }}
                          onClick={(e) => {
                            const _index = _.findIndex(stockDatas, {
                              id: stock?.id,
                            });
                            let _newStocks = [...stockDatas];
                            _newStocks[_index].currency = "ກີບ";
                            setStockDatas(_newStocks);
                          }}>
                          ກີບ
                        </Button>
                        <Button
                          style={{
                            backgroundColor:
                              stock?.currency == "ບາດ" ? "green" : "#eee",
                            color: stock?.currency == "ບາດ" ? "#ffff" : "#000",
                            width: 50,
                            borderWidth: 0,
                          }}
                          onClick={(e) => {
                            const _index = _.findIndex(stockDatas, {
                              id: stock?.id,
                            });
                            let _newStocks = [...stockDatas];
                            _newStocks[_index].currency = "ບາດ";
                            setStockDatas(_newStocks);
                          }}>
                          ບາດ
                        </Button>
                        <Button
                          style={{
                            backgroundColor:
                              stock?.currency == "ໂດລາ" ? "green" : "#eee",
                            color: stock?.currency == "ໂດລາ" ? "#ffff" : "#000",
                            width: 50,
                            borderWidth: 0,
                          }}
                          onClick={(e) => {
                            const _index = _.findIndex(stockDatas, {
                              id: stock?.id,
                            });
                            let _newStocks = [...stockDatas];
                            _newStocks[_index].currency = "ໂດລາ";
                            setStockDatas(_newStocks);
                          }}>
                          ໂດລາ
                        </Button>
                      </ButtonGroup>
                    </td>
                    <td>
                      <Form.Control
                        type="input"
                        value={stock?.categoryName}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].categoryName = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="input"
                        value={stock?.brandName}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].brandName = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="input"
                        value={stock?.subBrandName}
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].subBrandName = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                      />
                    </td>
                    <td>
                      <NumberFormatBase
                        name="shippingCost"
                        onChange={(e) => {
                          const _index = _.findIndex(stockDatas, {
                            id: stock?.id,
                          });
                          let _newStocks = [...stockDatas];
                          _newStocks[_index].shippingCost = e.target.value;
                          setStockDatas(_newStocks);
                        }}
                        value={stock?.shippingCost}
                        className="form-control"
                        placeholder="0"
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </td>
                    <td>
                      <button
                        className="btn hoverme"
                        onClick={() => {
                          let _newStocks = [...stockDatas];
                          _.remove(_newStocks, { id: stock?.id });
                          setStockDatas(_newStocks)
                          successSwal(`ລົບຂໍ້ມູນສໍາເລັດແລ້ວ`);

                        }}>
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          style={{ color: "red" }}
                        />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}

      </Card>


    </div>
  );
}

export default AddProductExcelV1;
